<div class="flexie-auto-grid m-t-b-60">

  <!-- <div class="flex-self-vert-start">
    <div *ngIf="!savedAdd">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2>Add Identity</h2>
        <p>You need to atleast one Identity Number to continue</p>
      </div>
    </div>
    <div *ngIf="savedAdd">
      <h3>Identity Details </h3>
      <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
        <ng-template #item let-item>
          <nz-list-item [nzActions]="[editAction,moreAction]">
            <nz-skeleton [nzActive]="true" [nzLoading]="false">
              <ng-template #moreAction><a (click)="edit(item)">select as Preffered</a></ng-template>
              <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
              <ng-template #moreAction><a (click)="view(item)">delete</a></ng-template>
              <nz-list-item-meta [nzTitle]="'KTP'" nzDescription="987 9874 9875">
              </nz-list-item-meta>
            </nz-skeleton>
          </nz-list-item>
        </ng-template>
      </nz-list>
    </div>
  </div> -->

  <div class="flex-self-vert-start">
    <div *ngIf="identityList && identityList.length < 1">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2 translate>Add Identity</h2>
        <p translate>You need to atleast one Identity Number to continue</p>
      </div>
    </div>
    <div *ngIf="identityList && identityList.length > 0">
      <h3 translate>Identity Details</h3>

      <div *ngFor="let item of identityList; let i = index;"
        class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center b-b-1 p-10">
        <div>

          <strong>{{(item.identityTypeCd | technicalTranslate) || '' |translate}} <span *ngIf="isVerified"><i nz-icon [nzType]="'check-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i></span></strong>
          <br>
          {{item.identityNum || '' |translate}}
        </div>
        <div>
          <a href="javascript:void(0)" (click)="editIdentity(item,i)">Edit</a> |
          <a href="javascript:void(0)" (click)="removeIdentity(item,i)">Remove</a>
        </div>
      </div>
    </div>
  </div>

  <div style="align-self: flex-start">
    <div class="form-secondary">

      <h3 class="form-secondary-heading">+ Add Identity</h3>

      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <form [formGroup]="identityCaptureForm" class="form-secondary-fields p-l-r-20 p-t-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Identity Type</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select id="identityTypeCd" nzShowSearch formControlName="identityTypeCd" style="width: 100%;" nzAllowClear
                nzPlaceHolder="Choose">
                <nz-option
                  *ngFor="let item of (lookup$.identityTypeCd | async) as identityTypeCdLookup; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
              </nz-select>
            </nz-form-control>
            <nz-form-explain
                *ngIf="(identityCaptureForm.get('identityTypeCd').dirty || identityCaptureForm.get('identityTypeCd').touched) && 
                  identityCaptureForm.get('identityTypeCd').errors">
                <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(identityCaptureForm.get('identityTypeCd'),IDENTITYCAPTYREFORMNAME)">
                    {{error.errorMessage}}</p>
            </nz-form-explain>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Identity Number</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input id="identityNumberInput" nz-input placeholder="Identity Number" formControlName="identityNumber" name="input-basic" />
            </nz-form-control>
            <nz-form-explain
                *ngIf="(identityCaptureForm.get('identityNumber').dirty || identityCaptureForm.get('identityNumber').touched) && 
                identityCaptureForm.get('identityNumber').errors">
                <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(identityCaptureForm.get('identityNumber'),IDENTITYCAPTYREFORMNAME)">
                    {{error.errorMessage}}</p>
            </nz-form-explain>
          </nz-form-item>
        </form>
      </div>

      <div class="footer-actions-bar">
        <div>
          <!-- Left -->
        </div>
        <div>
          <!-- Right -->
          <button nz-button class="b-0 m-r-10" (click)="clearForm()">Clear</button>
          <button nz-button [nzType]="'primary'" (click)="addIdentity()">Add</button>
        </div>
      </div>
    </div>
  </div>

</div>